import { Label } from "@EditArticleContainer/shared/components/EditableTextContainer/types/editableText.types";
import { PartnerAxisMAContent } from "@EditArticleContainer/shared/types/paragraphContents/contents/partnerAxisMAContent.types";
import { createMultiLineText } from "@utils/createMultiLineText/createMultiLineText";

export const licensorNameText = (paragraph: PartnerAxisMAContent) =>
  createMultiLineText({
    textList:
      paragraph.text["Licensor(MA)"][0]["Licensor Name(MA)"].value.map(
        (v) => v.text ?? "",
      ),
    parseString: (text) => `- ${text.trim()}`,
  });

export const licensorNameLabels = (paragraph: PartnerAxisMAContent): Label[] =>
  (paragraph.text["Licensor(MA)"][0]["Licensor Name(MA)"].value.at(0)
    ?.labels ?? []) as Label[];

export const licensorResponsibilityText = (paragraph: PartnerAxisMAContent) =>
  createMultiLineText({
    textList: paragraph.text["Licensor Responsibility & Rights"].value.map(
      (v) => v.text ?? "",
    ),
    parseString: (text) => `- ${text.trim()}`,
  });

export const licensorResponsibilityLabels = (
  paragraph: PartnerAxisMAContent,
): Label[] =>
  (paragraph.text["Licensor Responsibility & Rights"].value.at(0)
    ?.labels ?? []) as Label[];

export const licenseeNameText = (paragraph: PartnerAxisMAContent) =>
  createMultiLineText({
    textList:
      paragraph.text["Licensee(MA)"][0]["Licensee Name(MA)"].value.map(
        (v) => v.text ?? "",
      ),
    parseString: (text) => `- ${text.trim()}`,
  });

export const licenseeNameLabels = (paragraph: PartnerAxisMAContent): Label[] =>
  (paragraph.text["Licensee(MA)"][0]["Licensee Name(MA)"].value.at(0)
    ?.labels ?? []) as Label[];

export const licenseeResponsibilityText = (paragraph: PartnerAxisMAContent) =>
  createMultiLineText({
    textList: paragraph.text[
      "Licensee Responsibility & Rights (MA)"
    ].value.map((v) => v.text ?? ""),
    parseString: (text) => `- ${text.trim()}`,
  });

export const licenseeResponsibilityLabels = (
  paragraph: PartnerAxisMAContent,
): Label[] =>
  (paragraph.text["Licensee Responsibility & Rights (MA)"].value.at(0)
    ?.labels ?? []) as Label[];
